// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__oLScA","slide":"styles_slide__FAcDw","card":"styles_card__8AFTY"};